import {
  trackAddNewListingEvent,
  trackOpenContactUs,
} from "../../lib/tracking/trackNavigationEvents";

export const linksList1 = [
  {
    label: "شقق للإيجار",
    link: "/شقق-للإيجار",
    iconProps: {
      type: "Circle",
      size: "tiny",
      width: 10,
      height: 10,
    },
  },
  {
    label: "فلل للإيجار",
    link: "/فلل-للإيجار",
    iconProps: {
      type: "Circle",
      size: "tiny",
      width: 10,
      height: 10,
    },
  },
  {
    label: "دور للإيجار",
    link: "/دور-للإيجار",
    iconProps: {
      type: "Circle",
      size: "tiny",
      width: 10,
      height: 10,
    },
  },
  {
    label: "فلل للبيع",
    link: "/فلل-للبيع",
    iconProps: {
      type: "Circle",
      size: "tiny",
      width: 10,
      height: 10,
    },
    disableClientSideNav: true,
  },
];

export const linksList2 = [
  {
    label: "شقق للبيع",
    link: "/شقق-للبيع",
    iconProps: {
      type: "Circle",
      size: "tiny",
      width: 10,
      height: 10,
    },
  },
  {
    label: "أراضي للبيع",
    link: "/أراضي-للبيع",
    iconProps: {
      type: "Circle",
      size: "tiny",
      width: 10,
      height: 10,
    },
  },
  {
    label: "شقق للإيجار بالرياض",
    link: "/شقق-للإيجار/الرياض",
    iconProps: {
      type: "Circle",
      size: "tiny",
      width: 10,
      height: 10,
    },
  },
  {
    label: "شقق للإيجار بجدة",
    link: "/شقق-للإيجار/جدة",
    iconProps: {
      type: "Circle",
      size: "tiny",
      width: 10,
      height: 10,
    },
  },
];

export const linksList3 = [
  {
    label: "إضافة إعلان",
    link: "/add-listing/init/terms",
    textColor: "#52b54a",
    iconProps: {
      type: "AddCircle-colored",
      width: 20,
      height: 20,
    },
    onClick: () => {
      trackAddNewListingEvent({ source: "footer" });
    },
  },
  {
    label: "دفع الرسوم",
    link: "/services",
    iconProps: {
      type: "Fees",
      width: 20,
      height: 20,
    },
    disableClientSideNav: true,
  },
  {
    label: "التمويل العقاري",
    link: `/التمويل-العقاري`,
    iconProps: {
      type: "Calculator",
      width: 20,
      height: 20,
    },
  },
  {
    label: "متوسط الأسعار",
    link: `/الإحصائيات-العقارية`,
    iconProps: {
      type: "Equalizer",
      width: 20,
      height: 20,
    },
  },
  {
    label: "عقود الإيجار",
    link: `/عقود-الإيجار`,
    iconProps: {
      type: "Contracts",
      width: 20,
      height: 20,
    },
  },
];

export const linksList4 = [
  {
    label: "تمييز الإعلانات",
    link: `/add-featured`,
    iconProps: {
      type: "WebFeatured",
      width: 20,
      height: 20,
    },
  },
  {
    label: "مدونة عقار",
    link: "https://sa.aqar.fm/blog/",
    iconProps: {
      type: "Message",
      width: 20,
      height: 20,
    },
    disableClientSideNav: true,
  },
  {
    label: "شركاء النجاح",
    link: "/partners",
    iconProps: {
      type: "Profile",
      width: 20,
      height: 20,
    },
  },
  {
    label: "اتفاقية الاستخدام",
    link: "/اتفاقية-استخدام-تطبيق-عقار",
    iconProps: {
      type: "Terms",
      width: 20,
      height: 20,
    },
  },
  {
    label: "حاسبة البناء",
    iconProps: {
      type: "BuildingCalc",
      width: 20,
      height: 20,
    },
    link: `/حاسبة-البناء`,
  },
  {
    label: "اتصل بنا",
    iconProps: {
      type: "ContactUs",
      width: 20,
      height: 20,
    },
    link: `/تواصل-معنا#support`,
    onClick: () => {
      trackOpenContactUs({ source: "footer" });
    },
  },
];
